import { Button } from '@mui/material';
import { EventNote } from '@mui/icons-material';
import { H4, Body2 } from '../../../../themes/typography';
import '../../../../styles/user-dashboard/NoCreatedEvent.css';

function NoCreatedEvent({
    title = 'No events created yet',
    description = 'Start organizing memorable events for your community. Create your first event to get started.',
    shouldShowButton = true,
    onClick = () => { },
    btnName = 'Create Event',
    icon = <EventNote color="tertiary" sx={{ fontSize: '48px' }} />
}) {
    return (
        <div className="no-events-container">
            <div className="icon-container">
                {icon}
            </div>

            <div className="content-section">
                <H4>{title}</H4>
                <Body2 color="var(--gray-secondary-color)" fontWeight={300}>
                    {description}
                </Body2>
            </div>

            {shouldShowButton && (
                <Button variant="main" onClick={onClick}>
                    {btnName}
                </Button>
            )}

            {/* <p className="help-text">
                Need help? Check out our <button className="help-link">getting started guide</button>
            </p> */}
        </div>
    );
}

export default NoCreatedEvent;
